"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpectrumClassName = void 0;
var _useSpectrumConditional = require("@cbhq/cds-common/hooks/useSpectrumConditional");
var _spectrum = require("../styles/spectrum");
/**
 * Useful to attach spectrum className onto an element or to lookup CSS class properties via getComputedStyle.
 * @returns string - The CSS className for light or dark mode depending on the active spectrum.
 */
const useSpectrumClassName = () => {
  return (0, _useSpectrumConditional.useSpectrumConditional)({
    light: _spectrum.light,
    dark: _spectrum.dark
  });
};
exports.useSpectrumClassName = useSpectrumClassName;